import { Route } from '@angular/router';
import { PatientAuthComponent } from '@ic-monorepo/shared-auth-patient';
import { PageNotFoundComponent } from '@ic-monorepo/shared-components';

export const appRoutes: Route[] = [
  {
    path: '',
    redirectTo: 'entry',
    pathMatch: 'full',
  },
  {
    path: 'entry',
    title: 'Isla | Patient submission',
    loadChildren: () =>
      import('@ic-monorepo/feature-patient-submission').then(
        m => m.patientSubmissionRoutes,
      ),
  },
  {
    path: 'auth',
    component: PatientAuthComponent,
  },
  {
    path: 'patient-facing',
    title: 'Isla | Patient flow',
    loadChildren: () =>
      import('@ic-monorepo/feature-patient-open-submissions').then(m => m.patientOpenSubmissionRoutes),
  },
  {
    path: 'public/patient/:patientId/feedback',
    title: 'Isla | Patient - Feedback',
    loadComponent: () => import('@ic-monorepo/feature-patient-public').then(c => c.PatientFeedbackComponent),
  },
  {
    path: 'page-not-found',
    title: 'Isla | Page not found',
    component: PageNotFoundComponent,
  },
  { path: '**', redirectTo: '/page-not-found' },
];
